import api, { CustomerHistoryEvent } from '@api';
import { Search } from '@mui/icons-material';
import { DialogContent, InputAdornment, TextField } from '@mui/material';
import { FilledSection, RoutedDialog, RoutedDialogProps } from '@tsp-ui/core/components';
import { useAsyncEffect, usePageMessage } from '@tsp-ui/core/utils';
import { useCallback, useContext, useState } from 'react';

import { CustomerDetailContext } from '../../CustomerDetailPage';

import styles from './HistoryDialog.module.scss';
import HistoryEventCard from './HistoryEventCard';


export default function HistoryDialog(props: Omit<RoutedDialogProps, 'title' | 'children'>) {
    const { id: customerID } = useContext(CustomerDetailContext).customer!;
    const [ events, setEvents ] = useState<CustomerHistoryEvent[]>([]);
    const [ loading, setLoading ] = useState(true);

    const pageMessage = usePageMessage();

    useAsyncEffect(useCallback(async () => {
        try {
            setEvents(await api.customer.eventHistory.getHistory(customerID));
        } catch (error) {
            pageMessage.handleApiError('An error occurred while fetching the customer history', error);
        }

        setLoading(false);
    }, [ customerID, pageMessage ]));

    return (
        <RoutedDialog
            {...props}
            title="History"
            maxWidth={false}
            loading={loading}
        >
            <DialogContent className={styles.root}>
                <FilledSection
                    header={(
                        <>
                            Events

                            {/* TODO implement pagination and filtering */}

                            <TextField
                                autoFocus
                                variant="standard"
                                placeholder="Filter history events"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </>
                    )}
                    variant="light"
                    className={styles.section}
                >
                    {events.map(event => (
                        <HistoryEventCard
                            key={event.id}
                            event={event}
                        />
                    ))}
                </FilledSection>
            </DialogContent>
        </RoutedDialog>
    );
}
